const ANGLE_INTEGER_MESSAGE = "Enter whole numbers for degrees and minutes.";

/** Blank parts retain the forms' existing optional/zero semantics. */
export const isAnglePart = (raw: string): boolean => {
	const value = raw.trim();
	return (
		value === "" ||
		(/^[+-]?\d+$/.test(value) && Number.isSafeInteger(Number(value)))
	);
};

/** Decode decimal degrees at whole-minute precision, including the 60′ carry. */
export const splitAngle = (
	value: number | null,
): { Degrees: string; Minutes: string } => {
	if (value === null) return { Degrees: "", Minutes: "" };
	const totalMinutes = Math.round(value * 60);
	return {
		Degrees: String(Math.trunc(totalMinutes / 60)),
		Minutes: String(totalMinutes % 60),
	};
};

/** Validate entered units; only persisted decimal degrees are rounded on reading. */
export const combineAngle = (
	degrees: string,
	minutes: string,
): number | null => {
	if (!isAnglePart(degrees) || !isAnglePart(minutes))
		throw new Error(ANGLE_INTEGER_MESSAGE);
	if (degrees.trim() === "" && minutes.trim() === "") return null;
	return Number(degrees || 0) + Number(minutes || 0) / 60;
};
